export const Terms = {
  privacy:
    "https://help.alidrop.co/AliDrop-co-Privacy-Policy-b512f603d5584decb77da5449bf78bc4",
  terms:
    "https://help.alidrop.co/AliDrop-co-Terms-of-Service-b8471038b1de4b0484ac607ce067cdad",
  refund:
    "https://help.alidrop.co/What-is-AliDrop-s-Refund-Policy-c5b59df7875a430db194dd09e8ecc9dd",
};
